import { useQuery } from '@tanstack/react-query';

import { OnboardingConfigResponse } from '@Models';
import { bopsApi } from '@Network';

const useOnboardingConfig = (sourceName?: string) => {
  const { data, isLoading: isQueryLoading } = useQuery<OnboardingConfigResponse>({
    queryKey: ['onboarding-config', sourceName],
    queryFn: () => bopsApi.getOnboardingConfig(sourceName),
    enabled: !!sourceName,
    staleTime: 30 * 60 * 1000, // 30 min — config changes infrequently
  });

  // Stay in loading until an agent is selected so consumers can't make
  // gating decisions against a response fetched with sourceName=undefined.
  const isLoading = !sourceName || isQueryLoading;

  return {
    config: data,
    isActive: data?.isActive ?? false,
    questions: data?.questions ?? [],
    isLoading,
  };
};

export default useOnboardingConfig;
